import { render, staticRenderFns } from "./TakeVideo.vue?vue&type=template&id=d20a8b30&scoped=true&"
import script from "./TakeVideo.vue?vue&type=script&lang=js&"
export * from "./TakeVideo.vue?vue&type=script&lang=js&"
import style0 from "./TakeVideo.vue?vue&type=style&index=0&id=d20a8b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20a8b30",
  null
  
)

export default component.exports